import React from "react";

const ErrorMessage = ({ message }: { message: string }) => (
    <div
        style={{
            width: "100%",
            marginTop: "0.25rem",
            fontSize: "80%",
            color: "#f46a6a",
        }}
    >
        {message}
    </div>
);

export default ErrorMessage;
